import i18n from '@/i18n';
import moment from 'moment';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import jaLocale from '@fullcalendar/core/locales/ja';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { validateAllField } from '@/utils/validate_v2';

let eventGuid = 0;
let TITLE_HOLIDAY = '休日';

const CONFIG_TABLE_PRIZE_SERIAL_CODE = {
    headers: [
        { label: '賞品名' },
        { label: '画像' },
        { label: '種別' },
        { label: '当選確率' },
        { label: '当選時間' },
        { label: '現在の当選確率' },
        { label: '総当選数' },
        { label: '当選数' },
        { label: '残数' }
    ]
};

const CONFIG_TABLE_DIGITAL_GIF = {
    headers: [{ label: '賞品コード {$1}' }, { label: '内容１ {$2}' }, { label: '内容２ {$3}' }, { label: '済' }]
};

const JP_DAY_MAP = {
    日: 0,
    月: 1,
    火: 2,
    水: 3,
    木: 4,
    金: 5,
    土: 6,
    [TITLE_HOLIDAY]: 7
};

const LIST_DAY_OF_WEEK = ['日', '月', '火', '水', '木', '金', '土', TITLE_HOLIDAY];

const CONFIG_SCREEN_CALENDAR = {
    muliselectPrizes: {
        trackBy: 'make_id',
        label: 'title',
        error: false,
        isRemove: true
    },
    modalCreatEvent: {
        title: '賞品数を入力してください。',
        infoSelect: null,
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'md',
        centered: true,
        titleBtnSave: i18n.t('btn.save')
    },
    calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, bootstrapPlugin],
        themeSystem: 'bootstrap',
        locale: jaLocale,
        headerToolbar: {
            left: '',
            right: 'prev next',
            center: 'title'
        },
        initialView: 'dayGridMonth',
        contentHeight: 'auto',
        fixedWeekCount: false,
        events: [],
        editable: false,
        eventStartEditable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: false,
        weekends: true
    },
    LIST_NOTE_COLOR: [
        {
            id: 1,
            bgr_color: '#c8e9cb',
            label: 'Khoảng thời gian'
        },
        {
            id: 2,
            bgr_color: '#ffb6b6',
            label: 'Lịch nghỉ'
        },
        {
            id: 3,
            bgr_color: '#e0e0e0',
            label: 'Ngoài khoảng thời gian'
        },
        {
            id: 4,
            bgr_color: '#deccae',
            label: 'Trùng khoảng thời gian với ngày nghỉ'
        }
    ],
    eventTitleInput: {
        classCustom: 'input-event-title',
        maxlength: 5,
        isNumber: true
    }
};

const initFieldOther = () => {
    return {
        number_quantity_follow_day: null,
        number_quantity_modal_date: null,
        apiFullCalendar: null
    };
};

const toCalendarEnd = (endInclusive) => {
    return moment(endInclusive).add(1, 'day').format('YYYY-MM-DD');
};

const randomColor = () => {
    const COLOR_LIST = [
        '#3788d8' // purple
    ];
    return COLOR_LIST[Math.floor(Math.random() * COLOR_LIST.length)];
};

const filterDatesByWeekdays = (start, endInclusive, jpWeekdays, listHolidays = []) => {
    const isAllowedHoliday = jpWeekdays.includes(TITLE_HOLIDAY);
    const allowedDays = jpWeekdays.filter((item) => item !== TITLE_HOLIDAY).map((d) => JP_DAY_MAP[d]);
    const result = [];

    let current = moment(start);
    const end = moment(endInclusive);

    while (current.isSameOrBefore(end)) {
        if (allowedDays.includes(current.day())) {
            result.push(current.format('YYYY-MM-DD'));
        }
        current.add(1, 'day');
    }

    if (!isAllowedHoliday || listHolidays.length === 0) {
        return result.filter((item) => !listHolidays.map((h) => h.date).includes(item));
    }
    listHolidays.forEach((h) => {
        const date = h.date;
        const index = result.indexOf(date);
        if (index !== -1) {
            result[index] = date;
        } else {
            result.push(date);
        }
    });
    result.sort();
    return result;
};

const initFormCalendar = (data = null) => {
    return {
        prize_select: data?.prize_select ?? null,
        start_date_winning: data?.start_date_winning ?? null,
        end_date_winning: data?.end_date_winning ?? null,
        start_time_winning: data?.start_time_winning ?? null,
        end_time_winning: data?.end_time_winning ?? null,
        checked_day_of_week: data?.checked_day_of_week ?? LIST_DAY_OF_WEEK
    };
};

const configFormCalendar = () => {
    return {
        prize_select: {
            error: false,
            typesValidate: []
        },
        start_time_winning: {
            format: 'HH:mm',
            valueType: 'format',
            placeholder: '',
            type: 'time',
            clearable: false,
            error: false,
            errorField: '',
            typesValidate: []
        },
        end_time_winning: {
            format: 'HH:mm',
            valueType: 'format',
            placeholder: '',
            type: 'time',
            clearable: false,
            error: false,
            errorField: '',
            typesValidate: []
        }
    };
};

const onValidTime = (initForm, configInit, check) => {
    //start valid time
    configInit.start_time_winning.error = false;
    configInit.end_time_winning.error = false;
    configInit.start_time_winning.errorField = '';
    configInit.end_time_winning.errorField = '';
    if (
        (configInit.start_time_winning.typesValidate.includes('required') || configInit.end_time_winning.typesValidate.includes('required')) &&
        (!initForm.start_time_winning || !initForm.end_time_winning)
    ) {
        check = false;
        configInit.start_time_winning.isRequired = false;
        configInit.end_time_winning.isRequired = false;
        configInit.start_time_winning.error = true;
        configInit.end_time_winning.error = true;
        configInit.start_time_winning.errorField = i18n.t('validateField.required', {
            field: i18n.t('managerForm.settingSerialCode.winningTimeSetting')
        });
        return check;
    }

    const startTime = moment(initForm.start_time_winning, 'HH:mm');
    const endTime = moment(initForm.end_time_winning, 'HH:mm');
    if (!!initForm.start_time_winning && !!initForm.end_time_winning && !endTime.isSameOrAfter(startTime)) {
        check = false;
        configInit.end_time_winning.error = true;
        configInit.end_time_winning.errorField = i18n.t('validateField.compareTime');
    }
    // end valid time
    return check;
};

const handleValidCalendar = (initForm, configInit) => {
    let check = validateAllField(initForm, configInit);
    check = onValidTime(initForm, configInit, check) && check;
    return check;
};

const createEventId = () => {
    return String(eventGuid++);
};

const createIdEventRangeDate = (evt) => {
    return `follow-${evt.startStr}-${evt.endStr}`;
};

const validOrderDateAddEvent = (strDate, endDate, strDateEvent, endDateEvent) => {
    let check = true;
    const startAllow = new Date(strDate);
    const endAllow = new Date(endDate);
    const eventStart = new Date(strDateEvent);
    const eventEnd = new Date(endDateEvent);
    if (eventStart < startAllow || eventEnd > endAllow) check = false;
    return check;
};

const splitAllDayEvent = (event, type = 'allow-range') => {
    const events = [];
    const start = new Date(event.startStr);
    const end = new Date(event.endStr); // exclusive
    let current = new Date(start);
    while (current < end) {
        const next = new Date(current);
        next.setDate(current.getDate() + 1);
        if (type === 'allow-range') {
            events.push({
                id: createEventId(),
                title: event.title,
                start: new Date(current),
                end: new Date(next),
                startStr: moment(current).format('YYYY-MM-DD'),
                endStr: moment(next).format('YYYY-MM-DD'),
                allDay: true,
                constraint: 'allow-range'
            });
        } else if (type === 'holiday') {
            events.push({
                id: createEventId(),
                display: 'background',
                start: new Date(current),
                end: new Date(next),
                startStr: moment(current).format('YYYY-MM-DD'),
                endStr: moment(next).format('YYYY-MM-DD'),
                allDay: true,
                classNames: event?.classNames || [],
                extendedProps: event?.extendedProps || {}
            });
        }
        current = next;
    }
    return events;
};

const initInputRanges = (arr, numberQuantity = null) => {
    return arr.map((item) => {
        return {
            start: moment(item.start).format('YYYY-MM-DD'),
            end: moment(item.end).format('YYYY-MM-DD'),
            quantity: numberQuantity ? Number(numberQuantity) : Number(item.title) || 0,
            old_quantity: Number(item.title) || 0,
            daily_won: item?.extendedProps?.daily_won ?? null
        };
    });
};
const onHandleCompareNumberQuatity = ({ existedRanges = [], newRanges = [], max, isAllowMaximum = false, allEventBeforeToday = [] }) => {
    const mergedRanges = [...existedRanges];
    const dateQuantitySmallDailyWon = {};
    const totalBeforeToday = allEventBeforeToday?.length > 0 ? allEventBeforeToday?.reduce((a, b) => a + Number(b.title), 0) : null;
    newRanges.forEach((newRange) => {
        const existingIndex = mergedRanges.findIndex((existingRange) => existingRange.start === newRange.start && existingRange.end === newRange.end);
        if (existingIndex !== -1) {
            newRange.daily_won = mergedRanges[existingIndex].daily_won;
            newRange.old_quantity = mergedRanges[existingIndex].old_quantity;
            mergedRanges[existingIndex] = newRange;
        } else {
            mergedRanges.push(newRange);
        }
    });
    const quantityByDate = {};
    const applyRange = ({ start, end, quantity, daily_won, old_quantity }) => {
        let cur = moment(start);
        const last = moment(end);
        while (cur.isBefore(last, 'day')) {
            const date = cur.format('YYYY-MM-DD');
            const currentQty = quantityByDate[date] || 0;
            const newTotal = currentQty + quantity;

            if (daily_won && newTotal < daily_won) {
                quantityByDate[date] = old_quantity;
                dateQuantitySmallDailyWon[`${start}-${end}`] = quantityByDate[date];
            } else {
                quantityByDate[date] = newTotal;
            }
            cur.add(1, 'day');
        }
    };
    mergedRanges.forEach(applyRange);
    let total = Object.values(quantityByDate).reduce((a, b) => a + b, 0);
    if (total > max) {
        if (!isAllowMaximum) {
            return {
                valid: false,
                total,
                message: `合計件数が ${total} 件となって、${max}件を超えています。`
            };
        }

        if (totalBeforeToday) {
            if (totalBeforeToday === max) {
                return {
                    valid: false,
                    total,
                    message: `合計件数が ${total} 件となって、${max}件を超えています。`
                };
            }
            total = max - totalBeforeToday;
        } else {
            total = max;
        }
    }
    return {
        valid: true,
        total,
        dateQuantitySmallDailyWon
    };
};

const filterEventsByRange = (events, start, endInclusive) => {
    if (events?.length <= 0) return [];
    return events.filter((ev) => {
        const date = ev.startStr;
        return date >= start && date <= endInclusive;
    });
};

const objEventRange = (dataEvent, classNames = ['event-allow-range']) => {
    return {
        startStr: dataEvent.start_date,
        endStr: toCalendarEnd(dataEvent.end_date),
        start: dataEvent.start_date,
        end: toCalendarEnd(dataEvent.end_date),
        display: 'background',
        classNames: classNames,
        allDay: true
    };
};

const setYearHoliday = (events) => {
    return events.map((event) => {
        if (event.extendedProps?.type_holiday !== 'year_end_schedule') {
            return event;
        }
        const month = Number(event.startStr.split('-')[1]); // 1–12
        let yearHoliday = '';
        if (month === 12) yearHoliday = '年末';
        else if (month === 1) yearHoliday = '年始';
        return {
            ...event,
            extendedProps: {
                ...event.extendedProps,
                year_holiday: yearHoliday
            }
        };
    });
};

const onHandleHolidayDefault = (arrHoliday, valLottery) => {
    const rawHolidays = arrHoliday || [];
    const yearEndDates = new Set(rawHolidays.filter((item) => item.type === 'year_end_schedule').map((item) => item.date || item.start_date));
    const filteredHolidays = rawHolidays.filter((item) => {
        if (item.type === 'holiday') {
            const dateKey = item.date || item.start_date;
            return !yearEndDates.has(dateKey);
        }
        return true;
    });
    let valueFiltersHoliday = filteredHolidays
        ?.map((item) =>
            splitAllDayEvent(
                {
                    ...item,
                    startStr: item?.type === 'holiday' ? item?.date : item?.start_date,
                    endStr: item?.type === 'holiday' ? toCalendarEnd(item?.date) : toCalendarEnd(item?.end_date),
                    classNames: [`event-${item?.type}`],
                    extendedProps: {
                        type_holiday: item?.type,
                        holiday_name: item?.type === 'holiday' ? item?.title : '',
                        year_holiday: item?.type === 'year_end_schedule' ? item?.title : ''
                    }
                },
                'holiday'
            )
        )
        .flatMap((item) => item)
        .filter((event) => {
            const eventStart = event.startStr;
            const eventEnd = event.endStr;
            return (
                eventStart >= valLottery.start_date &&
                eventStart <= toCalendarEnd(valLottery.end_date) &&
                eventEnd >= valLottery.start_date &&
                eventEnd <= toCalendarEnd(valLottery.end_date)
            );
        });
    valueFiltersHoliday = setYearHoliday(valueFiltersHoliday);
    const uniqueEvents = [...new Map(valueFiltersHoliday.map((item) => [`${item.startStr}_${item.endStr}`, item])).values()];
    return uniqueEvents;
};

const isDateEqualToToday = (inputDate) => {
    const today = moment();
    const input = moment(inputDate);
    return input.isSameOrAfter(today, 'day');
};

const isDateBeforeToday = (inputDate) => {
    const today = moment();
    const input = moment(inputDate);
    return input.isBefore(today, 'day');
};

const filterTodayDates = (dateList) => {
    return dateList.filter((item) => {
        return isDateEqualToToday(item.startStr);
    });
};

const onHandleSumDailyLimitPrize = (prizeData, infoPrize) => {
    const listDailys =
        prizeData?.find(
            (item) =>
                (item?.make_id && infoPrize?.make_id && item.make_id === infoPrize.make_id) || (item?.id && infoPrize?.id && item.id === infoPrize.id)
        )?.prize_date_event?.daily_limits || [];
    return listDailys?.length > 0 ? listDailys?.reduce((total, item) => total + Number(item?.title), 0) : 0;
};

const splitRecordsByMaxQuantity = (data, maxQuantity, quantitySmallDailyWonDate) => {
    let currentTotal = 0;
    const accepted = [];
    const remaining = [];
    let isFull = false;
    for (const item of data) {
        const itemQuantity = item?.is_not_change_title
            ? Number(item.title) || 0
            : quantitySmallDailyWonDate[`${item?.startStr}-${item?.endStr}`]
              ? quantitySmallDailyWonDate[`${item?.startStr}-${item?.endStr}`]
              : Number(item.title) || 0;
        if (!isFull && currentTotal + itemQuantity <= maxQuantity) {
            accepted.push(item);
            currentTotal += itemQuantity;
        } else {
            isFull = true;
            remaining.push(item);
        }
    }
    return { accepted, remaining };
};

const buildSelectInfoFromEvent = (arg) => {
    if (arg.jsEvent) {
        arg.jsEvent.preventDefault();
        arg.jsEvent.stopPropagation();
    }
    const selectInfo = {
        start: arg.event.start,
        end: arg.event.end,
        startStr: arg.event.startStr,
        endStr: arg.event.endStr,
        allDay: arg.event.allDay,
        view: arg.view,
        jsEvent: arg.jsEvent,
        event: arg.event
    };
    return selectInfo;
};

const onValidQuantitySmallDailyWon = (quantity, existingEvent) => {
    return existingEvent.extendedProps.daily_won && quantity < existingEvent.extendedProps.daily_won;
};

const getExcludedDateEvents = (formCalenderInit, listHolidayCalendar, apiFullCalendar) => {
    if (!formCalenderInit || !apiFullCalendar) return [];
    const dateNotInclude = filterDatesByWeekdays(
        formCalenderInit.start_date_winning,
        formCalenderInit.end_date_winning,
        LIST_DAY_OF_WEEK.filter((item) => !formCalenderInit.checked_day_of_week.includes(item)),
        listHolidayCalendar
    );
    return apiFullCalendar
        .getEvents()
        .filter((item) => dateNotInclude.includes(item.startStr) && item.title)
        .map((item) => {
            return {
                allDay: true,
                constraint: 'allow-range',
                end: item.end,
                endStr: item.endStr,
                id: item.id,
                start: item.start,
                startStr: item.startStr,
                title: item.title,
                is_not_change_title: true
            };
        });
};

export {
    CONFIG_TABLE_PRIZE_SERIAL_CODE,
    CONFIG_TABLE_DIGITAL_GIF,
    JP_DAY_MAP,
    LIST_DAY_OF_WEEK,
    CONFIG_SCREEN_CALENDAR,
    TITLE_HOLIDAY,
    toCalendarEnd,
    randomColor,
    filterDatesByWeekdays,
    initFormCalendar,
    configFormCalendar,
    handleValidCalendar,
    createEventId,
    initFieldOther,
    validOrderDateAddEvent,
    onValidTime,
    splitAllDayEvent,
    onHandleCompareNumberQuatity,
    initInputRanges,
    filterEventsByRange,
    createIdEventRangeDate,
    objEventRange,
    onHandleHolidayDefault,
    isDateEqualToToday,
    isDateBeforeToday,
    filterTodayDates,
    onHandleSumDailyLimitPrize,
    splitRecordsByMaxQuantity,
    buildSelectInfoFromEvent,
    onValidQuantitySmallDailyWon,
    getExcludedDateEvents
};
